import { ITEM_FIELD_TYPE } from './ITEM_FIELD_TYPE';

export class ItemFieldPartTemplate {
    constructor(readonly fieldType: ITEM_FIELD_TYPE, readonly text: string) {
    }
}
